import { render, staticRenderFns } from "./Acedge.vue?vue&type=template&id=70dc8d28&scoped=true&"
import script from "./Acedge.vue?vue&type=script&lang=js&"
export * from "./Acedge.vue?vue&type=script&lang=js&"
import style0 from "./Acedge.vue?vue&type=style&index=0&id=70dc8d28&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc8d28",
  null
  
)

export default component.exports